import api from "./api";

// Cache buku alamat di memori aplikasi. Diisi lebih awal saat halaman Keranjang
// dibuka supaya Checkout bisa langsung memakainya tanpa menunggu jaringan.
// PR keamanan lanjutan B (audit lead 13): dikosongkan saat keluar / ganti akun (AuthContext, pola lib/prefetch); permintaan yang masih
// berjalan saat dikosongkan tidak boleh mengisi cache lagi dengan alamat akun sebelumnya (nomor generasi).
// Review Codex B2 putaran 1: cache & permintaan diikat ke TOKEN sesi saat diminta (token ditulis ke localStorage sebelum sesi baru dipasang,
// jadi pemeriksaan ini sinkron — tidak menunggu efek AuthContext). Token lain → cache tidak dikembalikan; permintaan yang selesai sesudah
// token berganti DITOLAK (`basi: true`), alamat akun lama tidak pernah sampai ke pemanggil.
let cache = null;     // { token, isi }
let pending = null;   // { token, janji }
let generasi = 0;

const tokenSekarang = () => { try { return localStorage.getItem("hs_token") || ""; } catch { return ""; } };
function galatBasi() { const e = new Error("Akun berganti; alamat akun sebelumnya dibuang"); e.basi = true; return e; }

export const getCachedAddresses = () => (cache && cache.token === tokenSekarang() ? cache.isi : null);

export function fetchAddresses({ force = false } = {}) {
  const token = tokenSekarang();
  const ada = getCachedAddresses();
  if (ada && !force) return Promise.resolve(ada);
  if (!pending || pending.token !== token) {
    const gen = generasi;
    const janji = api.get("/api/addresses")
      .then(({ data }) => {
        if (gen !== generasi || tokenSekarang() !== token) throw galatBasi();
        const isi = data || [];
        cache = { token, isi };
        return isi;
      })
      .finally(() => { if (pending && pending.janji === janji) pending = null; });
    pending = { token, janji };
  }
  return pending.janji;
}

export function clearAddressCache() { cache = null; pending = null; generasi += 1; }
